// ClientViewOrder.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

function ClientViewOrder() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const docRef = doc(db, 'orders', orderId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setOrder(docSnap.data());
        } else {
          console.warn('No such order!');
        }
      } catch (err) {
        console.error('Error loading order:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId]);

  if (loading) return <p>Loading order...</p>;
  if (!order) return <p>Order not found.</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Order Details</h2>
      <p><strong>Job Number:</strong> {order.jobNumber}</p>
      <p><strong>Status:</strong> {order.status}</p>
      <p><strong>Created:</strong> {order.createdAt?.toDate?.().toLocaleDateString() || 'N/A'}</p>
      <p><strong>Campaign:</strong> {order.campaignName || 'N/A'}</p>
      <p><strong>Quantity:</strong> {order.quantity || 'N/A'}</p>
      <p><strong>Printer:</strong> {order.printer || 'N/A'}</p>
      <p><strong>Attachment:</strong> {order.attachment || 'N/A'}</p>
      <p><strong>Notes:</strong> {order.notes || 'None'}</p>
    </div>
  );
}

export default ClientViewOrder;
